module.exports = {
    tag: 'cousity',
    quality: 0.6,
    perception: 3
};